import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/privacy")({
  head: () => seoMeta({
    title: "Informativa sulla Privacy - LexAIPro",
    description: "Come Belead (LexAIPro) tratta i dati personali ai sensi del GDPR.",
    path: "/privacy",
  }),
  component: () => (
    <ContentPage
      eyebrow="Legale"
      title="Informativa sulla Privacy"
      lead="La presente informativa descrive come Belead, titolare del trattamento, raccoglie e tratta i dati personali nell'ambito del servizio LexAIPro."
      breadcrumbs={[{ name: "Home", path: "/" }, { name: "Privacy", path: "/privacy" }]}
      sections={[
        {
          heading: "Titolare del trattamento",
          body: "Belead (di seguito anche 'noi'), che opera il servizio LexAIPro, è il titolare del trattamento dei dati personali raccolti tramite questo sito e l'applicazione. Per qualsiasi richiesta è possibile contattarci all'indirizzo beleadcreativestudio@proton.me.",
        },
        {
          heading: "Categorie di dati personali raccolti",
          bullets: [
            "Dati di account: nome, cognome, email, password (in forma hashed), credenziali di accesso",
            "Dati professionali: studio, ordine forense, numero di iscrizione, PEC, telefono",
            "Contenuti caricati dall'utente: documenti, atti, prompt e output AI",
            "Dati di utilizzo e telemetria: log applicativi, query AI effettuate, indirizzo IP, user agent",
            "Dati di pagamento e fatturazione: trattati direttamente da Paddle (vedi sezione condivisione)",
            "Comunicazioni di supporto: messaggi, email e contenuti delle richieste di assistenza",
          ],
        },
        {
          heading: "Finalità e basi giuridiche del trattamento",
          bullets: [
            "Fornitura del servizio, gestione dell'account e adempimento del contratto (art. 6.1.b GDPR)",
            "Sicurezza, prevenzione frodi e abusi, integrità della piattaforma - legittimo interesse (art. 6.1.f)",
            "Adempimenti fiscali, contabili e di legge - obbligo di legge (art. 6.1.c)",
            "Miglioramento del prodotto e analisi aggregate - legittimo interesse (art. 6.1.f)",
            "Comunicazioni commerciali e marketing - solo previo consenso (art. 6.1.a)",
            "Assistenza clienti e gestione delle richieste - esecuzione del contratto / legittimo interesse",
          ],
        },
        {
          heading: "Destinatari e condivisione dei dati",
          body: "I dati possono essere comunicati alle seguenti categorie di destinatari, tutti vincolati da accordi di trattamento:",
          bullets: [
            "Fornitori di hosting e infrastruttura cloud (UE)",
            "Fornitori di modelli di intelligenza artificiale per l'elaborazione delle query",
            "Paddle.com Market Limited, Merchant of Record per la gestione di ordini, pagamenti, fatturazione, IVA, abbonamenti, rimborsi e relativi adempimenti fiscali",
            "Fornitori di strumenti di analytics, monitoring e supporto",
            "Consulenti professionali (legali, fiscali, contabili)",
            "Autorità pubbliche, ove richiesto da obbligo di legge",
          ],
        },
        {
          heading: "Periodo di conservazione",
          bullets: [
            "Dati dell'account: per tutta la durata del rapporto contrattuale e fino a 24 mesi dalla chiusura, salvo obblighi di legge superiori",
            "Documenti caricati e cronologia AI: fino alla cancellazione da parte dell'utente o alla chiusura dell'account",
            "Dati di fatturazione: 10 anni come da normativa fiscale italiana",
            "Log tecnici e di sicurezza: fino a 12 mesi",
            "Decorsi i termini, i dati sono cancellati o resi anonimi in modo irreversibile",
          ],
        },
        {
          heading: "Trasferimenti internazionali",
          body: "I dati sono ospitati prevalentemente nell'Unione Europea. Eventuali trasferimenti verso paesi terzi avvengono esclusivamente sulla base di decisioni di adeguatezza della Commissione Europea o di Clausole Contrattuali Standard (SCC) ai sensi degli artt. 44-49 GDPR.",
        },
        {
          heading: "Diritti dell'interessato",
          bullets: [
            "Accesso, rettifica e cancellazione dei dati",
            "Limitazione e opposizione al trattamento",
            "Portabilità dei dati",
            "Revoca del consenso in qualsiasi momento",
            "Reclamo all'Autorità Garante per la Protezione dei Dati Personali (www.garanteprivacy.it)",
            "Per esercitare i diritti scrivere a beleadcreativestudio@proton.me",
          ],
        },
        {
          heading: "Misure di sicurezza",
          body: "Adottiamo misure tecniche e organizzative adeguate: cifratura in transito (TLS) e a riposo, controllo degli accessi basato su ruoli, segregazione degli ambienti, logging e monitoraggio, backup periodici, valutazioni di sicurezza ricorrenti.",
        },
        {
          heading: "Cookie",
          body: "Il sito utilizza esclusivamente cookie tecnici essenziali al funzionamento del servizio e all'autenticazione. Non utilizziamo cookie analitici, di profilazione o di marketing.",
        },
      ]}
      cta={{ label: "Contattaci", to: "/contatti" }}
      heroImage={pickContent(31)}
      updated="Maggio 2026"
    />
  ),
});
